export default __webpack_public_path__ + "static/media/cmeHero.875d43dd.jpg";